import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { InfluencerAnalyticsComponent } from './influencer-analytics.component';



const routes: Routes = [
    {
        path: '',
        component: InfluencerAnalyticsComponent
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class InfluencerAnalyticsRoutingModule { }
